"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTitle = exports.StyledTextWrapper = exports.StyledSingleAccordion = exports.StyledDescription = exports.StyledAccordionGroup = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _typography = require("../../fuse-typography-element/src/typography");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledAccordionGroup = exports.StyledAccordionGroup = _styledComponents["default"].div.attrs({
  className: 'fuse-accordion-group'
}).withConfig({
  displayName: "styled-accordion-group__StyledAccordionGroup",
  componentId: "sc-ihvmjp-0"
})([""]);
var StyledSingleAccordion = exports.StyledSingleAccordion = _styledComponents["default"].div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'hideBorder';
  }
}).attrs({
  className: 'fuse-accordion'
}).withConfig({
  displayName: "styled-accordion-group__StyledSingleAccordion",
  componentId: "sc-ihvmjp-1"
})(["", ""], function (_ref) {
  var hideBorder = _ref.hideBorder;
  return "\n\t\tborder-top: ".concat(hideBorder ? "none" : "1px solid var(--color-global-grey400)", ";\n\n\t\t&:last-of-type {\n\t\t\tborder-bottom: ").concat(hideBorder ? "none" : "1px solid var(--color-global-grey400)", ";\n\t\t}\n\n\t\t&.fuse-accordion:hover {\n\t\t\tborder-color: var(--color-brand-mid);\n\t\t}\n\n\t\t&.fuse-accordion:hover + .fuse-accordion {\n\t\t\tborder-top: ").concat(hideBorder ? "none" : "1px solid var(--color-brand-mid)", ";\n\t\t}\n\t");
});
var StyledTextWrapper = exports.StyledTextWrapper = _styledComponents["default"].div.attrs({
  className: 'fuse-accordion-group__text-wrapper'
}).withConfig({
  displayName: "styled-accordion-group__StyledTextWrapper",
  componentId: "sc-ihvmjp-2"
})(["gap:var(--spacing-global-space3);display:flex;flex-direction:column;"]);
var StyledTitle = exports.StyledTitle = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-accordion-group__title'
}).withConfig({
  displayName: "styled-accordion-group__StyledTitle",
  componentId: "sc-ihvmjp-3"
})(["margin-bottom:0;"]);
var StyledDescription = exports.StyledDescription = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-accordion-group__description'
}).withConfig({
  displayName: "styled-accordion-group__StyledDescription",
  componentId: "sc-ihvmjp-4"
})(["margin-bottom:0;"]);